import type { Game, Opponent, Player, Season, Snapshot, StatEvent, ID } from '../domain/types'

/**
 * The whole persistence surface. Screens only ever talk to this interface, so a
 * Supabase-backed implementation can be dropped in later without touching UI code.
 * Every method is async for that reason, even where IndexedDB could be sync-ish.
 */
export interface Repo {
  readonly kind: 'indexeddb' | 'localstorage'
  init(): Promise<void>

  listPlayers(): Promise<Player[]>
  savePlayer(p: Player): Promise<void>
  /** Only for removing rows created in error; archiving is the normal path. */
  deletePlayer(id: ID): Promise<void>

  listOpponents(): Promise<Opponent[]>
  saveOpponent(o: Opponent): Promise<void>

  listSeasons(): Promise<Season[]>
  saveSeason(s: Season): Promise<void>

  listGames(): Promise<Game[]>
  getGame(id: ID): Promise<Game | undefined>
  saveGame(g: Game): Promise<void>
  deleteGame(id: ID): Promise<void>

  listEventsByGame(gameId: ID): Promise<StatEvent[]>
  listAllEvents(): Promise<StatEvent[]>
  saveEvent(e: StatEvent): Promise<void>
  saveEvents(events: StatEvent[]): Promise<void>

  getMeta<T>(key: string): Promise<T | undefined>
  setMeta<T>(key: string, value: T): Promise<void>

  exportAll(): Promise<Snapshot>
  importAll(snapshot: Snapshot): Promise<void>
  clearAll(): Promise<void>
}

export const META_CURRENT_GAME = 'currentGameId'
export const META_CURRENT_SEASON = 'currentSeasonId'
export const META_LAST_EXPORT = 'lastExportAt'
